<template>
  <div ref="modal" class="modal-card" style="width: auto">
    <b-loading  :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <header class="modal-card-head">
      <p class="modal-card-title">Attach Documents</p>
    </header>
    <section class="modal-card-body">
      <div>
        <b-upload v-model="files"
            multiple
            drag-drop>
            <section class="section">
                <div class="content has-text-centered">
                    <p>Drop or click to upload</p>
                </div>
            </section>
        </b-upload>
      </div>
      <div>
        <div v-for="(file, index) in files"
            :key="index"
            class="tag is-primary">
            {{file.name}}
            <button class="delete is-small"
                type="button"
                @click="deleteFile(index)">
            </button>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-outlined is-primary is-fullwidth" @click="$parent.close()">Cancel</button>
      <button class="button is-primary is-fullwidth" :disabled="files.length == 0" @click="uploadDocs" >Save</button>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DocumentUploaderCard',
  props: ['dropFiles', 'recordID', 'docPortal', 'purchaseOrderID'],
  data () {
    return {
      files: this.dropFiles,
      createdRecordID: null,
      isLoading: false,
      isFullPage: true
    };
  },
  computed:{
    ...mapState([
      'userInfo',
    ]),
 
  },
  methods:{
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    
    // Creates a document record in FileMaker containing the document for upload
    uploadDocs: function(){
      self = this;
      self.isLoading = true;
      // Loop through docs to upload
      this.files.forEach(function(file){
        // Create a form element to simulate submitting a form 
        let formData = new FormData();
        //strip weird characters out of file name
        var newFileName = file.name.replace(/[^\w\s._-]/gi, '')
        var renamedFile = new File ([file], newFileName)
        //Add the file that was selected to our FormData object
        formData.append('upload', renamedFile);
        
        // Create a new record to store the document
        self.$http.post('api/v2/createRecord.php?layout=DOCUMENT&poID=' + self.purchaseOrderID + '&employeeName=' + self.userInfo.employeeName)
        .then( response => {
          if(response.data.messages[0].code === "401"){
            self.$toast.open(response.data.messages[0].message);
            return;
          }
          if(response.data.messages[0].code != 0){
            self.$toast.open(response.data.messages[0].message);
            return;
          }
          self.createdRecordID = response.data.response.recordId;
          self.postDocument(formData);
          // Emit to partent to alert it to refresh the data
          
        })
        .catch( error => {
          if (error.response) {
            self.$toast.open(error.response.status);
          } 
          else {
            self.$toast.open("Unknown Error");
          }
        });
      }); // For each
      self.files = [];
    },
    
    // Uploads the document from FileMaker, emits to parent when it's complete
    postDocument: function(formData){
      self = this;
      // The latest version of the proxy file can now handle uploads too.
      this.$http.post( "api/v2/upload.php?recid=" + this.createdRecordID + "&layout=DOCUMENT&container=document",
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then( response => {
          if(response.data.messages[0].code === "401"){
            self.$toast.open(response.data.messages[0].message);
            return;
          }
          if(response.data.messages[0].code  != 0){
            self.$toast.open(response.data.messages[0].message);
            return;
          }
          // Emit to parent that the post is done
          self.$emit('load-data', null);
        }) // Then
        .catch( error => {
          if (error.response) {
            self.$toast.open(error.response.status);
          } 
          else {
            self.$toast.open("Unknown Error");
          }
        }); // Catch, post
    },
    // Closes card window when done posting
    closeWindow: function(){
      this.$parent.close();
    }
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/PurchaseOrder/DocumentUploaderCard.vue